const Selectors = {
  widget: {
    target: '[data-testid="skipper-main-content"]',
    waitFor: ".cash-widget-overlay-container",
    mobileWidgetTarget: '[data-testid="cash--widget-header"]',
    widgetDesktop: "#gustbook-widget-desktop",
    widget: "#guestbook-widget",
    stickyWidget: "#guestbook-sticky-widget",
  },
  ratesPage: {
    waitFor: ".cash--room-card-container",
    contentChangeTarget: ".cash--room-card-container, [data-testid='cash--offers-list']",
    rates: ".cash--room-card-price-cost, .cash--room-rate-list-price",
    ratesCodes: "NA",
    ratesMessage: ".gb-rates-message", 
    currency: "NA",
    selectRoomPageScroll: '[data-testid="skipper-layout"] > div > section > div',
    selectOfferPageScroll: '[data-testid="skipper-layout"] > div > section',
  },
  paymentPage: {
    waitFor: ".cash--booking-details",
    contentChangeTarget: ".cash--booking-details",
    nights: '.cash--booking-details-content section:first-child div:nth-child(3) span:nth-child(2)',
    email: "slot[name='email']",
    emailInput: 'body>div[id^=skipper] [name="email"]',
    firstNameInput: 'body>div[id^=skipper] [name="firstName"]',
    lastNameInput: 'body>div[id^=skipper] [name="lastName"]',
    enrollmentTarget: "aside:nth-child(2) > div",
    enrollmentMessageContainer: "#guestbook-enrollment",
  },
  confirmationPage: {
    waitFor: '.cash--booking-details-confirmed',
    messageTarget: "aside:nth-child(2) > div > div:last-child",
    confirmationNumbers: ".cw-bg-secondary-background div span",
    roomName: '.cash--booking-details-confirmed section:nth-child(2) div:nth-child(5) span:nth-child(2)',
    nights: '.cash--booking-details-confirmed section:nth-child(2) div:nth-child(3) span:nth-child(2)',
    total: '[slot=total_cost] [slot=data] div:first-child',
    contentChangeTarget: ".cash--booking-details-confirmed",
    confirmationMessageContainer: "#guestbook-confirm",
  },
  cancellation: {
    cancellationTarget: "NA",
    cancellationNumber: "NA",
    confirmationNumber: "NA",
  }
};

export default Selectors;
